module.exports = __webpack_public_path__ + "static/media/name.14e249ef.svg";